import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { mergeStyles, PrimaryButton, WindowProvider } from '@fluentui/react';
import * as ReactDOM from 'react-dom';
let currentTarget;
const clearCurrentTarget = ()=>{
    if (currentTarget !== undefined) {
        ReactDOM.unmountComponentAtNode(currentTarget);
        currentTarget.remove();
        currentTarget = undefined;
    }
};
export function ShowSensitivityLabelErrorDialog(informationProtectionStringTable, error, styles, stylingProviderThemeProperties, ownerDocument) {
    const doc = ownerDocument || document;
    // Create a render element required by ReactDOM render
    currentTarget = doc.createElement('div');
    ReactDOM.render(/*#__PURE__*/ React.createElement(WindowProvider, {
        window: doc.defaultView || undefined
    }, /*#__PURE__*/ React.createElement(SensitivityLabelErrorDialog, {
        informationProtectionStringTable: informationProtectionStringTable,
        error: error,
        styles: styles,
        stylingProviderThemeProperties: stylingProviderThemeProperties,
        onDismissed: clearCurrentTarget
    })), currentTarget);
}
/**
 * This control is invoked if changing the sensitivity label requires downgrade justification. This
 * control ensures to collect the user justification and appropriately invokes the setSensitivityLabel
 * API.
 */ export const SensitivityLabelErrorDialog = /*#__PURE__*/ React.memo((props)=>{
    const [hideDialog, setHideDialog] = React.useState(false);
    const dialogContentProps = React.useMemo(()=>{
        return {
            type: DialogType.normal,
            title: props.informationProtectionStringTable.sensitivityLabelErrorDialogMandatoryText,
            subText: props.informationProtectionStringTable.sensitivityLabelErrorDialogMandatorySubText
        };
    }, [
        props.informationProtectionStringTable
    ]);
    const modalProps = {
        isBlocking: true,
        className: mergeStyles(props.stylingProviderThemeProperties),
        styles: props.styles?.modal,
        onDismissed: props.onDismissed
    };
    const onDismiss = React.useCallback(()=>{
        setHideDialog(true);
    }, []);
    return /*#__PURE__*/ React.createElement(Dialog, {
        hidden: hideDialog,
        onDismiss: onDismiss,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps
    }, /*#__PURE__*/ React.createElement(DialogFooter, {
        styles: {
            actions: {
                lineHeight: 'inherit'
            }
        }
    }, /*#__PURE__*/ React.createElement(PrimaryButton, {
        onClick: onDismiss,
        text: props.informationProtectionStringTable.sensitivityLabelErrorDialogCloseButtonText,
        styles: props.styles?.defaultButton
    })));
});
